import React, { ElementRef } from 'react';

import { Box, BoxProps, Text } from '@betterment/samba-react';
import { RecipeVariantProps, css, cva } from '@betterment/samba-styled-system/css';

const customTagStyles = cva({
  base: {
    ml: 'space.100',
    px: 'space.100',
    borderRadius: 'round',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
  },
  variants: {
    variant: {
      success: {
        bg: 'background.success',
      },
    },
  },
});

type CustomTagProps = BoxProps & RecipeVariantProps<typeof customTagStyles>;

export const BoostedTag = React.forwardRef<ElementRef<'div'>, CustomTagProps>(
  ({ children, css: cssProp, ...props }, forwardedRef) => {
    const className = css(customTagStyles.raw({ variant: 'success' }), cssProp);
    return (
      <Box className={className} ref={forwardedRef} {...props}>
        <Text variant="text25" color="text" css={{ lineHeight: 'lineHeight.50' }}>
          Boosted
        </Text>
      </Box>
    );
  }
);
